import React from 'react'
import './SemiCircularProgress.css'
import { useAppSelector } from '../../app/hooks'
import { selectAnalysisData, selectDomainCss } from '../analysis/AnalysisSlice'
export interface SemiCircularProgressProps {
  value: number
}
const SemiCircularProgress = (props: SemiCircularProgressProps) => {
  const domainCss = useAppSelector(selectDomainCss)
  const analysisData = useAppSelector(selectAnalysisData)
  return (
    <div role="semicircularprogressbar" style={{
      ['--value' as any]: props.value,
      ['--primaryC' as any]: analysisData?.customize?.secondaryColor ? analysisData?.customize?.secondaryColor : domainCss?.primary.main,
      ['--secondaryC' as any]: '#ffffff',
    }}>
      <span style={{ fontSize: 40, color: analysisData?.customize?.secondaryColor ? analysisData?.customize?.secondaryColor : domainCss?.primary.main }}>{props.value}%</span>
    </div>
  )
}

export default SemiCircularProgress